import { loginUser } from "../components/authRoutes";
import { useNavigate } from "react-router";
import { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Link } from 'react-router-dom'

const LoginUser = (props) => {
    const setLoginVisible = props.mods.setLoginVisible
    const setCurrentUser = props.mods.setCurrentUser
    const setIsAuthenticated = props.mods.setIsAuthenticated
    const initialState = { username: "", password: ""}
    const navigate = useNavigate()
    const [input, setInput] = useState(initialState)
    const [errorState, setErrorState] = useState(false)
    
    function errorMessage() {
        setErrorState(true)
        setTimeout(() => {
            setErrorState(false)
        }, 3000)
    }

    useEffect(() => {
        setLoginVisible(false)
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const user = await loginUser(input)
        if (user.isLoggedIn) {
            setCurrentUser(user)
            setIsAuthenticated(user.isLoggedIn)
            navigate("/")
        } else {
            errorMessage()
        }
        setInput(initialState)
    }

    const handleChange = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value})
    }

    return (
        <Container className="dateContainer">
        
        <Form onSubmit={handleSubmit}>
            <Row>
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Username: </Form.Label>
                <Form.Control type="text" onChange={handleChange} name="username" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password: </Form.Label>
                <Form.Control type="password" onChange={handleChange} name="password" />
            </Form.Group>
            </Row>
            <Row>
                <Col xs={3} className="d-flex justify-content-center">
                    <Button variant="info" type="submit" className="defaultButton">Login</Button>
                </Col>
                <Col xs={4} className="d-flex justify-content-center">
                    <Link to="/auth/register"><Button variant="dark" className="defaultButton editButton">Sign Up</Button></Link>
                </Col>
            </Row>    
        </Form>
        {(errorState === true) ? <p>There was an error. Please try again</p> : null}
        </Container>
    )
}

export default LoginUser